module.exports = __webpack_public_path__ + "img/promptpay.c3d6401a.png";